import { useEffect, useRef } from 'react'
import type { ISoundPlayer } from './sound-player'

export function useAudioUnlock(sound: ISoundPlayer) {
  const unlockedRef = useRef(false)
  useEffect(() => {
    if (unlockedRef.current) return
    function handler() {
      if (unlockedRef.current) return
      unlockedRef.current = true
      sound.unlock().catch(() => {})
      if (import.meta.env.MODE !== 'production' && import.meta.env.MODE !== 'prod') {
        ;(window as Window & { __alertSoundUnlocked__?: boolean }).__alertSoundUnlocked__ = true
      }
      document.removeEventListener('click', handler)
      document.removeEventListener('keydown', handler)
    }
    document.addEventListener('click', handler)
    document.addEventListener('keydown', handler)
    return () => {
      document.removeEventListener('click', handler)
      document.removeEventListener('keydown', handler)
    }
  }, [sound])
}
